import { EffectComposer, Bloom, ChromaticAberration } from "@react-three/postprocessing";
import { BlendFunction } from "postprocessing";

export default function PostFX({ bloomIntensity = 1.2, glitch = false }) {
  return (
    <EffectComposer disableNormalPass multisampling={0}>
      <Bloom
        luminanceThreshold={0.15}
        luminanceSmoothing={0.4}
        intensity={bloomIntensity}
        mipmapBlur
      />
      <ChromaticAberration
        offset={glitch ? [0.0025, 0.0018] : [0.0004, 0.0003]}
        blendFunction={BlendFunction.NORMAL}
      />
    </EffectComposer>
  );
}
